// extracted by mini-css-extract-plugin
export var categoryNumber = "seasonalPassCategory-module--categoryNumber--jxSHn";
export var seasonalPassCategory = "seasonalPassCategory-module--seasonalPassCategory--drIUD";
export var seasonalPassCategory__price = "seasonalPassCategory-module--seasonalPassCategory__price--Len06";
export var seasonalPassCategory__priceReduced = "seasonalPassCategory-module--seasonalPassCategory__priceReduced--MLjKk";
export var seasonalPassCategory__titleRow = "seasonalPassCategory-module--seasonalPassCategory__titleRow--E4Y6v";